<template>
  <v-container fluid>
    <div class="text-center px-0 pb-2 mb-3">
      <v-card-text class="pb-2">
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8"
        >
          Links
        </div>
      </v-card-text>
      <v-container style="overflow-x: scroll">
        <v-row class="flex-nowrap">
          <v-col
            v-for="item in links"
            v-bind:key="item.buttonText"
            style="min-width: 225px"
          >
            <v-card>
              <v-card-text class="pb-2">
                <div
                  class="font-weight-medium"
                  style="font-size: 0.95rem !important; height: 35px; display: flex; align-items: center; justify-content: center"
                >
                  {{ item.title }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  block
                  v-bind:href="item.url"
                >
                  {{ item.buttonText }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-card class="text-center px-5 pb-5">
      <v-card-text>
        <v-card-subtitle class="text--secondary text-caption py-0"
          >GBS {{ new Date().getFullYear() }}</v-card-subtitle
        >
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8"
        >
          Material
        </div>
      </v-card-text>
      <v-treeview
        v-model="tree"
        :items="items"
        item-key="name"
        open-on-click
        expand-icon="mdi-chevron-down"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="!item.file">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
          <v-icon v-else>mdi-file</v-icon>
        </template>
        <template v-slot:append="{ item }">
          <v-icon v-if="item.file" @click="download(item.path)" :title="item.path"
            >mdi-tray-arrow-down</v-icon
          >
        </template>
      </v-treeview>
      <v-divider />
      <v-card-actions>
        <v-btn
          block
          depressed
          class="white--text"
          color="tertiary"
          @click="toRepository()"
          >Zum Repository</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<!-- TODO: give feedback, when Login credentials are wrong -->

<script>
import { baseUrl } from "@/constants";
export default {
  name: "Home",
  data: () => ({
    folders: null,
    files: null,
    repository: "https://gitlab.lrz.de/gbs2425/material",
    items: [],
    tree: [],
    links: [
      {
        title: 'Folien, Quizzes und Ankündigungen',
        buttonText: 'Moodle',
        url: 'https://www.moodle.tum.de/course/view.php?id=100579',
      },
      {
        title: 'Programmieraufgaben',
        buttonText: 'Artemis',
        url: 'https://artemis.ase.cit.tum.de/courses/386/exercises',
      },
      {
        title: 'Forum für Fragen',
        buttonText: 'Zulip',
        url: 'https://zulip.in.tum.de/#narrow/stream/481-GBS',
      },
      {
        title: 'VL-Streams und Aufzeichnungen',
        buttonText: 'TUM-Live',
        url: 'https://live.rbg.tum.de/?year=2024&term=W&view=3&slug=ws24GBuS',
      },
    ],
  }),
  methods: {
    download(path){
      window.open(
        path,
        "_blank" // <- This is what makes it open in a new window.
      );
    },
    showFiles(folder) {
      if (!this.files) return [];
      const f = this.files.filter((f) => f.folder == folder);
      if (!f.length) return f;
      f.sort(function (a, b) {
        const nameA = a.title.toUpperCase(); // Groß-/Kleinschreibung ignorieren
        const nameB = b.title.toUpperCase(); // Groß-/Kleinschreibung ignorieren
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // Namen müssen gleich sein
        return 0;
      });
      return f;
    },
    leftoverFiles() {
      if (!this.files) return [];
      if (!this.folders) return this.files;
      const folders = this.folders.map((f) => f.id);
      const f = this.files.filter((f) => !folders.includes(f.folder));
      if (!f.length) return f;
      f.sort(function (a, b) {
        const nameA = a.title.toUpperCase(); // Groß-/Kleinschreibung ignorieren
        const nameB = b.title.toUpperCase(); // Groß-/Kleinschreibung ignorieren
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // Namen müssen gleich sein
        return 0;
      });
      return f;
    },
    sortFilesByTitle(nameA, nameB) {
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // Namen müssen gleich sein
      return 0;
    },
    toRepository() {
      window.open(this.repository, "_blank").focus();
    },
    getChildren(parentId) {
      let children = this.folders.filter((f) => f.parent == parentId);
      children = children.map((f) => {
        return {
          name: f.slug,
          children: this.getChildren(f.id),
        };
      });
      children = children.concat(
        this.files
          .filter((f) => f.folder == parentId)
          .map((f) => {
            const url = new URL(f.file);
            return {
              name: f.title,
              file: true,
              path: baseUrl.slice(0, -1) + url.pathname + url.search + url.hash,
            };
          })
      );
      // JS: Order all elements by type (folders first, files second) and then name (ascending)
      children.sort((a, b)=> (a.children == undefined) - (b.children == undefined) || a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
      //console.log(parentId, children);
      return children;
    },
  },
  created() {
    this.$axios.get("material-folders").then((response) => {
      this.folders = response.data;
      this.$axios.get("material-files").then((response) => {
        this.files = response.data;
        this.items = this.getChildren(null);
      });
    });
  },
};
</script>

<style>
.v-expansion-panels button {
  background-color: transparent !important;
  font-weight: initial !important;
}

.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-icon.v-icon:after {
  background-color: transparent !important;
}

.v-treeview-node__label {
  text-align: left;
  padding-left: 10px;
}
</style>

<style scoped>
.theme--light.v-expansion-panels .v-expansion-panel {
  border-bottom: thin solid rgb(230, 230, 230);
}

.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex: none !important;
}

.v-list-item {
  padding: 0px 24px;
}

.other-file-list {
  padding: 0px 24px;
}
</style>
